import { createSelector } from '@reduxjs/toolkit';

import { AppState } from '../reducers/root';
import { NotificationsViewModel } from '../slices/notifications';

export const getNotifications = (state: AppState): NotificationsViewModel =>
  state.notifications;

export const getNotificationsCount = createSelector(
  getNotifications,
  notifications => Object.keys(notifications).length
);
